<template>
	<div>
		<div class="page-header">
			<v-img src="@/assets/img/page-header-bg.jpeg" position="center"></v-img>
			<div class="page-title" v-if="pageData">
				<h1>{{ pageData.title }}</h1>
			</div>
		</div>
		<v-container class="py-16">
			<div class="fill-height w-100 d-flex align-center justify-center" v-if="loading">
				<v-progress-circular
					indeterminate
					color="primary"
				></v-progress-circular>
			</div>
			<div v-else>
				<v-row align="center" v-if="pageData.image">
					<v-col sm="6">
						<v-card height="500px" max-height="500px" color="grey lighten-2">
							<v-img v-if="pageData.image" :lazy-src="pageData.image" max-height="100%" max-width="100%" contain />
						</v-card>
					</v-col>
					<v-col sm="6">
						<div v-html="pageData.content"></div>
					</v-col>
				</v-row>
				<template v-else>
					<div v-html="pageData.content"></div>
				</template>
			</div>
		</v-container>
	</div>
</template>

<script>
export default {
	name: "Default",
	data: () => ({
		pageData: null,
		loading: true,
	}),
	methods: {
		fetchPageData() {
			if(!this.$route.params.slug) this.$router.push({ name: 'Home' })

			this.$axios.get(`site/${this.$route.meta.beforeSlug}/${this.$route.params.slug}`)
			.then(({ data }) => {
				this.pageData = data
			})
			.catch(() => this.$router.push({ name: 'Home' }))
			.finally(() => this.loading = false)
		}
	},
	watch: {
		'$route.params.slug'(val) {
			this.fetchPageData()
		}
	},
	mounted() {
		this.fetchPageData()
	},
}
</script>

<style scoped>

</style>